import NaveBarPaginas from "../Layout/NaveBarPaginas";
import styles from "./ReferencialP.module.css";
import ref1 from "../../Imgs/Ref/ref1.png";
import ref2 from "../../Imgs/Ref/ref2.png";
import ref3 from "../../Imgs/Ref/ref3.png";
import ref4 from "../../Imgs/Ref/ref4.png";
import ref5 from "../../Imgs/Ref/ref5.png";
function ReferencialP() {
  return (
    <div className={styles.container}>
      <NaveBarPaginas></NaveBarPaginas>

      {/*Ref03*/}
      <div className={styles.conteudo}>
        <img src={ref3} alt="capa"></img>
        <div className={styles.desc}>
          <h2>Homo ludens: O jogo como elemento da cultura</h2>
          <p>
            <span>Autor(es):</span> Johan Huizinga
          </p>
          <p>
            <span>Resumo:</span> Homo ludens é a obra mais importante na
            filosofia da história em nosso século. Escritor de inteligência
            aguda e poderosa, ajudado por um dom de expressão e exposição que é
            muito raro, huizinga reúne e interpreta um dos elementos
            fundamentais da cultura humana: o instinto do jogo. Lendo este
            volume, logo se descobre quão profundamente as realizações na lei,
            na ciência, na poesia, na guerra, na filosofia e nas artes são
            nutridas pelo instinto do jogo. [Roger Caillois]. Reedição, revista
            e reestrutu­rada com tradução do filósofo luso-brasileiro João Paulo
            Monteiro revista e adaptada por Newton Cunha.
          </p>
          <a
            target="_blank"
            href="https://www.amazon.com.br/Homo-Ludens-Johan-Huizinga/dp/8527311577"
            rel="noreferrer"
          >
            Link
          </a>
        </div>
      </div>

      {/*Ref01*/}
      <div className={styles.conteudo}>
        <img src={ref1} alt="capa"></img>
        <div className={styles.desc}>
          <h2>
            Geografia em jogo: algumas possibilidades de abordagem dos
            videogames na Geografia
          </h2>
          <p>
            <span>Autor(es):</span> Washington Drummond da Silva
          </p>
          <p>
            <span>Resumo:</span> O presente artigo está inserido no campo de
            estudos da nova geografia cultural e enseja explorar algumas
            possibilidades de interpretações das representações espaciais
            elaboradas pelos videogames, a partir da ótica geográfica.
          </p>
          <a
            target="_blank"
            href="https://revistas.ufg.br/atelie/article/view/35202#:~:text=Resumo&text=O%20presente%20artigo%20est%C3%A1%20inserido,ve%C3%ADculo%20disp%C3%B5e%20em%20sua%20r%C3%A9cita."
            rel="noreferrer"
          >
            Link
          </a>
        </div>
      </div>

      {/*Ref02*/}
      <div className={styles.conteudo}>
        <img src={ref2} alt="capa"></img>
        <div className={styles.desc}>
          <h2>Gamificação: diálogos com a educação</h2>
          <p>
            <span>Autor(es):</span> Lynn Rosalina Gama Alves
            <br></br>Marcelle Rose da Silva Minho
            <br></br>Marcelo Vera Cruz Diniz
          </p>
          <p>
            <span>Resumo:</span> A discussão sobre o processo de gamificação
            cresce em diferentes espaços, nos cenários acadêmicos, de marketing
            e/ou profissionais e já vem influenciando práticas, inclusive
            educacionais. Dentro desse contexto, o Grupo de Pesquisa Comunidades
            Virtuais, em parceria com os Centros Juvenis de Ciência e Cultura da
            Secretaria da Educação do Estado da Bahia (SEC/Ba), promoveu um
            curso de formação para os professores, objetivando discutir e pensar
            práticas gamificadas. O presente capítulo socializa as reflexões e
            propostas para a construção de trilhas que vão além da ênfase na
            recompensa, criando condições de colaboração e promovendo diferentes
            aprendizagens.
          </p>
          <a
            target="_blank"
            href="http://repositoriosenaiba.fieb.org.br/handle/fieb/667"
            rel="noreferrer"
          >
            Link
          </a>
        </div>
      </div>

      {/*Ref04*/}
      <div className={styles.conteudo}>
        <img src={ref4} alt="capa"></img>
        <div className={styles.desc}>
          <h2>
            Bem vindo a Los Santos: a Geografia em Grand Theft Auto V e sua
            aplicabilidade na educação
          </h2>
          <p>
            <span>Autor(es):</span> Phelipe Zaché Gonçalves
          </p>
          <p>
            <span>Resumo:</span> Esse trabalho tem como temática a utilização de
            recursos para o ensino de geografia, com o objetivo principal de
            analisar como os jogos podem ser ferramentas viáveis para uma aula,
            especificamente o jogo Grand Theft Auto V. Para tal, discutimos a
            respeito do que é jogo, com ênfase nos jogos eletrônicos comerciais,
            perpassando pelas suas características e formas de aprendizagem.
            Posteriormente, é desenvolvida uma metodologia de análise dos jogos
            pela geografia, que é usada para destrinchar o jogo objeto desta
            pesquisa, identificando diálogos com as referências dessa ciência.
            Por fim, apresentamos a proposta de aula e o relato da experiência
            para uma turma do segundo ano do Ensino Médio.
          </p>
          <a
            target="_blank"
            href="https://www.bdtd.uerj.br:8443/bitstream/1/13429/1/Dissertacao%20Phelipe%20Zache%20Goncalves%20%20final-1-77.pdf"
            rel="noreferrer"
          >
            Download da dissertação
          </a>
        </div>
      </div>

      {/*Ref05*/}
      <div className={styles.conteudo}>
        <img src={ref5} alt="capa"></img>
        <div className={styles.desc}>
          <h2>VIDEOGAME E ENSINO: A Geografia nos Games</h2>
          <p>
            <span>Autor(es):</span> Marcos Rodrigues Ornelas de Lima
          </p>
          <p>
            <span>Resumo:</span> Os jogos eletrônicos possuem uma espacialidade
            que tem se mantido longe das salas de aula, seja pela não
            apropriação dos games como objeto da Geografia Escolar, ou ainda
            pela não utilização dos videogames como ferramentas de ensino. O
            presente artigo busca contribuir com algumas questões no sentido de
            aproximar Geografia, games e ensino, tendo como referência práticas
            desenvolvidas no NuGAME – Núcleo de Games, Atividades e Metodologia
            de Ensino – no Colégio Pedro II.
          </p>
          <a
            target="_blank"
            href="https://www.cp2.g12.br/ojs/index.php/GIRAMUNDO/article/download/207/208#:~:text=VIDEOGAME%20E%20ENSINO%3A%20A%20GEOGRAFIA%20NOS%20GAMES.,-PR%C3%81TICAS%20PEDAG%C3%93GICAS&text=RESUMO%3A%20OS%20JOGOS%20ELETR%C3%B4NICOS%20POSSUEM,VIDEOGAMES%20COMO%20FERRAMENTAS%20DE%20ENSINO."
            rel="noreferrer"
          >
            Download do artigo
          </a>
        </div>
      </div>
    </div>
  );
}
export default ReferencialP;
